import type { StorefrontProduct } from '../lib/dropify'

export const HOME_POPULAR_PRODUCT_SLUGS = [
  'sarung-tangan-gekko-grip-nitrile-hitam',
  'stocking-celana-apple-b08b',
  'manset-tato-l1',
] as const

export const HOME_NEW_PRODUCT_SLUGS = [
  '26004-pajama-set',
  'handuk-cotton-1209-letonia-20260522-069',
  'bh-128-fengyuer-super-soft-wireless',
] as const

export const HOME_BESTSELLER_PRODUCT_SLUGS = [
  'kaos-kaki-bola-vieri',
  'dd-32b-keset-lantai-karakter-20260521-015',
  'handuk-mp-polos',
] as const

export const HOME_ALL_PRODUCTS_PRIORITY_SLUGS = [
  'handuk-mp-motif-70x140-cm',
  'handuk-mp-polos',
  'dd-32b-keset-lantai-karakter-20260521-015',
  'sarung-tangan-gekko-grip-nitrile-hitam',
  'sarung-tangan-matahari-putih-dot-hitam-all-size',
  'sarung-tangan-bulldozer',
  'sarung-tangan-diamond-kk-katalog-084',
  'manset-tato-l1',
  'stocking-celana-apple-b08b',
  'bra-wa-001-bh-a5-lingcao-asli',
] as const

export function mergeHomeAllProducts(
  priorityProducts: StorefrontProduct[],
  latestProducts: StorefrontProduct[],
  limit = 12,
) {
  const seen = new Set<string>()

  return [...priorityProducts, ...latestProducts].filter((product) => {
    const identity = product.id || product.slug
    if (seen.has(identity) || seen.size >= limit) return false
    seen.add(identity)
    return true
  })
}

// Shared by the homepage accordion and its FAQPage JSON-LD.
export const HOME_FAQ_ITEMS = [
  {
    q: 'Berapa minimum order (MOQ) untuk pembelian grosir?',
    a: 'Minimum order berbeda tiap kategori, misalnya handuk mulai 10 lusin dan kaos kaki 50 lusin. Untuk jumlah di bawah ketentuan umum, kirim nama produk dan jumlah kepada admin agar kemungkinan pengecualian dapat diperiksa.',
    link: { href: '/minimum-order', label: 'Lihat ketentuan minimum order tiap kategori' },
  },
  {
    q: 'Apakah bisa pesan campuran ukuran dan warna?',
    a: 'Ketentuan campur ukuran dan warna berbeda per produk. Kirim nama produk serta pembagian varian yang dibutuhkan agar admin dapat memeriksanya sebelum quotation dibuat.',
  },
  {
    q: 'Apakah bisa kirim sample dulu?',
    a: 'Bisa. Total biaya sampel terdiri dari harga satuan produk dan ongkir. Hubungi admin melalui WhatsApp untuk meminta sampel produk yang Anda pilih.',
  },
  {
    q: 'Apakah ada diskon untuk pembelian rutin atau langganan?',
    a: 'Harga mengikuti produk dan jumlah pada setiap pesanan. Kirim kebutuhan rutin beserta perkiraan jumlah per periode agar admin dapat menyiapkan quotation yang sesuai.',
  },
  {
    q: 'Metode pembayaran apa saja yang tersedia?',
    a: 'Pembayaran dilakukan melalui transfer bank BCA atau Mandiri. Dalam alur biasa, admin mengonfirmasi pembayaran sebelum pesanan disiapkan. Pembeli yang ingin memeriksa barang lebih dulu dapat meminta alur verifikasi melalui ekspedisi pilihan.',
    link: { href: '/jaminan-ekspedisi', label: 'Lihat alur verifikasi lewat ekspedisi' },
  },
  {
    q: 'Berapa lama proses pengiriman setelah pembayaran dikonfirmasi?',
    a: 'Setelah pembayaran dikonfirmasi, tim kami menyiapkan pesanan. Admin akan memberi estimasi waktu penyiapan dan perjalanan berdasarkan isi pesanan, ekspedisi, serta kota tujuan.',
  },
  {
    q: 'Bagaimana proses pengiriman pesanan?',
    a: 'Dalam alur biasa, barang disiapkan setelah pembayaran dikonfirmasi. Untuk alur verifikasi ekspedisi, barang diserahkan ke cabang pilihan yang disepakati dan resinya dikirim agar pembeli dapat mengecek sebelum transfer. Admin menjelaskan estimasi penyiapan dan pengiriman untuk alur yang dipilih.',
  },
  {
    q: 'Bagaimana memastikan produk sesuai dengan pesanan?',
    a: 'Periksa nama merek, kode model, ukuran, warna, jumlah, dan isi kemasan pada quotation. Jika barang yang diterima berbeda dari rincian pesanan, hubungi admin dengan foto label dan kemasannya untuk pemeriksaan.',
  },
  {
    q: 'Apakah tersedia katalog produk lengkap?',
    a: 'Website menampilkan kategori dan produk yang dapat digunakan sebagai referensi awal. Harga, stok, ukuran, warna, dan produk yang belum tampil perlu dikonfirmasi melalui WhatsApp.',
  },
  {
    q: 'Apakah tersedia harga khusus untuk pembelian partai besar?',
    a: 'Harga mengikuti produk dan jumlah. Kirim daftar SKU serta volume yang dibutuhkan agar admin dapat menyiapkan quotation.',
  },
  {
    q: 'Di mana saja Dropify melayani pengiriman?',
    a: 'Kami melayani pengiriman dari Surabaya ke berbagai wilayah Indonesia. Waktu tiba bergantung pada kota tujuan, ekspedisi, dan jenis layanan. Kirim kota tujuan kepada admin untuk meminta pilihan pengiriman beserta estimasinya.',
  },
  {
    q: 'Apakah bisa bayar dengan sistem COD?',
    a: 'Saat ini Dropify tidak melayani COD. Pembayaran dilakukan melalui transfer bank BCA atau Mandiri. Untuk alur verifikasi ekspedisi pilihan, pembeli dapat transfer setelah menerima resi dan menyelesaikan pengecekan yang disepakati dengan cabang.',
  },
  {
    q: 'Saya baru akan mulai berjualan. Informasi apa yang perlu saya kirim?',
    a: 'Boleh. Kirim kategori, target pembeli, perkiraan jumlah, dan kota tujuan. Admin akan menjelaskan pilihan produk, MOQ, quotation, dan cara order.',
    link: { href: '/cara-jadi-reseller', label: 'Pelajari cara jadi reseller Dropify' },
  },
]
